/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FeatureIcon = ({ width = 24, height = 24, hidden = false, title = 'Feature' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 2.2A15.8 15.8 0 1 0 33.8 18 15.8 15.8 0 0 0 18 2.2Zm12.2 12.574-6.726 5.392 2.274 8.308a.355.355 0 0 1-.237.443.351.351 0 0 1-.306-.049L18 24.144l-7.206 4.731a.355.355 0 0 1-.543-.394l2.274-8.315L5.8 14.774a.355.355 0 0 1 .208-.639l8.61-.408 3.05-8.063a.355.355 0 0 1 .671 0l3.05 8.063 8.61.408a.355.355 0 0 1 .348.362.351.351 0 0 1-.147.277Z"
    />
  </svg>`;
};
